module.exports = __webpack_public_path__ + "img/01.2cf5f5c2.png";